import React from "react";
import { makeStyles } from "@mui/styles";
import { Background } from "./survey/client/Background";
import { MobileStepper, Modal } from '@mui/material';
import logo from '../assets/img/logo_blanco.png';
import { useSurvey } from "../hooks/encuestas/useSurvey";
import { NotFound } from "./survey/client/NotFound";
import { ChaoticOrbit } from "@uiball/loaders";

export const Survey = () => {

    const classes = useStyles();
    const { content, step, active, loading } = useSurvey();

    return (
        <div className={ classes.main }>
            <Background />
            <Modal
                open={true}
                className={ classes.modal }
                BackdropProps={{ style: { background: 'none' } }}
                // BackdropProps={{ style: { background: '#00365F', opacity: .5 } }}
            >  
                <>  
                    {   
                        loading ? <ChaoticOrbit size={35} speed={1.5} color='#fff' />
                            : !active 
                            ? <NotFound />
                            : (
                                <>
                                    {
                                    
                                        ((step > 0) && (step < content.length - 1)) && (
                                                <MobileStepper
                                                    variant="dots"
                                                    steps={content?.length-2}
                                                    position="static"
                                                    activeStep={step -1}
                                                    classes={{
                                                        root: classes.root,
                                                        dot: classes.dot,
                                                        dotActive: classes.dotActive,
                                                    }}
                                                />
                                            )
                                    }
                                    { content[step] }
                                </>
                            )
                    }
                    
                    {/* <img src={ logo } alt="logo" className={ classes.image } />  */}
                </>
            </Modal>
        </div>
    )
}

const useStyles = makeStyles({
    main: {
        position: 'relative', 
        width: '100%', 
        height: '100%',
    },
    modal: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    image: {
		width: 150,
		position: 'absolute',
		top: 10,
		left: 10
	},
    pages: {
        color: '#fff',
        fontSize: '1.4rem',
        position: 'fixed',
        bottom: 15,
    },
    root: {
        maxWidth: 500, 
        flexGrow: 1,
        position: 'fixed', 
        bottom: 10, 
        background: 'none !important'
    },
    dot: {
        background: '#fff !important',
        width: '13px !important',
        height: '13px !important',
    },
    dotActive: {
        background: '#00365F !important',
        border: '2px solid #fff',
        width: '13px !important',
        height: '13px !important',
    }
});